(function () {
  'use strict';

  // Shopify's search doesn't match partial or mistyped product codes, so "16" or "1907" (for
  // 1097) find nothing useful. Every product's code is the leading digits of its handle
  // (1097262-chef-shirt-smart-unisex), so the full list is loaded once and matched here.
  // The first four digits are the model (1097), the full seven are one product (1097262).

  var MAX_CODES = 8;
  var MAX_NEAR = 4;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cacheKey = 'sg-search-codes:' + root;
  var loading = null;

  function fetchPage(page) {
    return fetch(root + '?section_id=sg-search-codes&page=' + page)
      .then(function (response) {
        if (!response.ok) throw new Error('Codes request failed');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var node = doc.querySelector('[data-sg-search-codes]');
        return JSON.parse(node ? node.textContent : '{"pages":0,"products":[]}');
      });
  }

  function load() {
    if (loading) return loading;
    try {
      var cached = sessionStorage.getItem(cacheKey);
      if (cached) {
        loading = Promise.resolve(JSON.parse(cached));
        return loading;
      }
    } catch (e) {}
    loading = fetchPage(1)
      .then(function (first) {
        var rest = [];
        for (var page = 2; page <= first.pages; page++) rest.push(fetchPage(page));
        return Promise.all(rest).then(function (pages) {
          return pages.reduce(function (all, p) { return all.concat(p.products); }, first.products);
        });
      })
      .then(function (rows) {
        var products = rows
          .filter(function (row) { return /^\d{7}$/.test(row[0]); })
          .map(function (row) { return { code: row[0], title: row[1], url: row[2] }; });
        try { sessionStorage.setItem(cacheKey, JSON.stringify(products)); } catch (e) {}
        return products;
      })
      .catch(function () {
        loading = null;
        return [];
      });
    return loading;
  }

  // 1 for one transposed, changed, added or dropped digit, otherwise 2. Transpositions are
  // ranked first, since swapping two digits is the most common way to mistype a code.
  function nearness(a, b) {
    if (a === b) return 0;
    if (a.length === b.length) {
      var diffs = [];
      for (var i = 0; i < a.length; i++) if (a[i] !== b[i]) diffs.push(i);
      if (diffs.length === 1) return 2;
      if (diffs.length === 2 && diffs[1] === diffs[0] + 1 &&
          a[diffs[0]] === b[diffs[1]] && a[diffs[1]] === b[diffs[0]]) return 1;
      return 0;
    }
    var longer = a.length > b.length ? a : b;
    var shorter = a.length > b.length ? b : a;
    if (longer.length - shorter.length !== 1) return 0;
    for (var j = 0; j < longer.length; j++) {
      if (longer.slice(0, j) + longer.slice(j + 1) === shorter) return 3;
    }
    return 0;
  }

  // People usually get the start of a code right, so among equally near codes, those that keep
  // more of what was typed come first.
  function sharedStart(a, b) {
    var i = 0;
    while (i < a.length && i < b.length && a[i] === b[i]) i++;
    return i;
  }

  // One entry per model or product code, labelled with its first product's title minus the code.
  function group(products, keyLength) {
    var byKey = {};
    var keys = [];
    products.forEach(function (product) {
      var key = product.code.slice(0, keyLength);
      if (!byKey[key]) {
        byKey[key] = { code: key, title: product.title.replace(/^\s*\d+\s*/, '').trim() };
        keys.push(key);
      }
    });
    return keys.map(function (key) { return byKey[key]; });
  }

  // Returns { kind: 'prefix' | 'near', codes: [{ code, title }] }, or null when the term isn't
  // a code or is already an exact one.
  function suggest(term) {
    var digits = String(term || '').replace(/[\s-]/g, '');
    if (!/^\d{2,}$/.test(digits)) return Promise.resolve(null);
    if (digits.length > 7) digits = digits.slice(0, 7);

    return load().then(function (products) {
      if (!products.length) return null;
      var keyLength = digits.length <= 4 ? 4 : 7;
      var starting = products.filter(function (p) { return p.code.indexOf(digits) === 0; });

      if (starting.length) {
        if (digits.length === 4 || digits.length === 7) return null;
        var codes = group(starting, keyLength).sort(function (a, b) { return a.code < b.code ? -1 : 1; });
        return { kind: 'prefix', codes: codes.slice(0, MAX_CODES) };
      }

      if (digits.length < 3) return null;
      var candidates = group(products, Math.max(digits.length, 4))
        .map(function (entry) {
          return { entry: entry, rank: nearness(digits, entry.code), kept: sharedStart(digits, entry.code) };
        })
        .filter(function (c) { return c.rank > 0; })
        .sort(function (a, b) {
          return a.rank - b.rank || b.kept - a.kept || (a.entry.code < b.entry.code ? -1 : 1);
        });
      if (!candidates.length) return null;
      return {
        kind: 'near',
        codes: candidates.slice(0, MAX_NEAR).map(function (c) { return c.entry; })
      };
    });
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  // Labels come from the t filter, which HTML-escapes them.
  function decodeText(html) {
    var el = document.createElement('textarea');
    el.innerHTML = html || '';
    return el.value;
  }

  // labels: { didYouMean, codesStartingWith } where codesStartingWith contains [code].
  function render(result, term, labels, searchUrl) {
    if (!result) return '';
    var digits = String(term).replace(/[\s-]/g, '').slice(0, 7);
    var heading = result.kind === 'near'
      ? decodeText(labels.didYouMean)
      : decodeText(labels.codesStartingWith).replace('[code]', digits);
    var chips = result.codes.map(function (entry) {
      var href = searchUrl + '?q=' + encodeURIComponent(entry.code) + '&type=product';
      return '<li><a class="sg-search-chip" href="' + escapeHtml(href) + '" data-sg-code="' + escapeHtml(entry.code) + '">' +
        '<span class="sg-search-chip__code">' + escapeHtml(entry.code) + '</span>' +
        (entry.title ? '<span class="sg-search-chip__title">' + escapeHtml(entry.title) + '</span>' : '') +
        '</a></li>';
    }).join('');
    return '<p class="sg-search-suggest__heading">' + escapeHtml(heading) + (result.kind === 'near' ? '?' : '') + '</p>' +
      '<ul class="sg-search-suggest__list">' + chips + '</ul>';
  }

  window.SGSearchCodes = { load: load, suggest: suggest, render: render };
})();
